module.exports = __webpack_public_path__ + "static/Flowchart-mobile-a900a17f1e6b1efaac71e4f87ee35996.svg";